import { render, staticRenderFns } from "./vData.vue?vue&type=template&id=6d6bbcd5"
import script from "./vData.vue?vue&type=script&lang=js"
export * from "./vData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports